/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

/**
 * Props for the TableColGroup Component
 */
export type TableColGroupProps = {
  tableId: string;
  columnWidthsArray: (number | undefined)[];
};

/**
 * The internal component used to render a single colgroup in Table.
 */
export function TableColGroup({ tableId, columnWidthsArray }: TableColGroupProps) {
  const getColStyle = (columnWidth?: number) => {
    return columnWidth == null ? '' : `width: ${columnWidth}px;`;
  };

  return (
    <colgroup>
      {columnWidthsArray.map((columnWidth?: number) => {
        return <col style={getColStyle(columnWidth)} data-oj-table-col={tableId} />;
      })}
    </colgroup>
  );
}
